module.exports = __webpack_public_path__ + "static/feature-1-2465d6f309d18049670b8e1dcedf3b5b.svg";